// import { InfoWindow } from '@agm/core/services/google-maps-types';
import { Component,  ElementRef,  Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { DeviceService } from 'src/app/services/devices/device.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import * as L from 'leaflet';
import 'leaflet-control-geocoder';

const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';


@Component({
    selector: 'app-geolocation',
    templateUrl: './geolocation.component.html',
    styleUrls: ['./geolocation.component.scss'],
    standalone: false
})
export class GeolocationComponent {

  @Input() allSettings = false;
  device: string = '';
  latitud: number = 0;
  longitud: number = 0;
  orignalLat: number = 0;
  orignalLng: number = 0;
  change = true;
  modalLoad: NgbModalRef;

  error: string = '';
  successMessage: boolean = false;

  address : string = '';
  map: L.Map;
  marker: L.Marker;

  constructor(public _device: DeviceService, private _aRoute: ActivatedRoute, private _modal: ModalService) { }

  ngOnInit(): void {
    this._aRoute.parent?.parent?.params.subscribe((params: Params) => this.device = params['serial']);

    this._device.getModuleInfoRemote(this.device, 'geolocation', "cfg").subscribe((data) => {
      this.latitud = parseFloat(data?.cfg?.latitude) || 40.4563988;
      this.longitud = parseFloat(data?.cfg?.longitude) || -3.7002338;
      this.orignalLat = this.latitud;
      this.orignalLng = this.longitud;

      this.initMap();
    })

  }

  initMap(): void {
     this.map = L.map('map').setView([this.latitud, this.longitud], 17);

        // Capa base de OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.map);

        setTimeout(() => {
          const geocoderContainer = document.querySelector('.leaflet-control-geocoder') as HTMLElement;
          if (geocoderContainer) {
            geocoderContainer.classList.add('leaflet-control-geocoder-expanded');
            const input = geocoderContainer.querySelector('input') as HTMLInputElement;
            // Comentado para evitar scroll automático al cargar la página
            // if (input) input.focus();
          }
        }, 300);

        // Añadir marcador inicial
        this.marker = L.marker([this.latitud, this.longitud]).addTo(this.map);
        this.changeGeolocation(this.latitud, this.longitud);

        // Evento: hacer clic para mover marcador
        this.map.on('click', (e: L.LeafletMouseEvent) => {
          this.latitud = e.latlng.lat;
          this.longitud = e.latlng.lng;

          this.marker.setLatLng([this.latitud, this.longitud]);
          this.changeGeolocation(this.latitud, this.longitud);
        });

        // Añadir buscador con leaflet-control-geocoder
        (L.Control as any).geocoder({
          defaultMarkGeocode: false
        })
        .on('markgeocode', (e) => {
          const center = e.geocode.center;
          this.latitud = center.lat;
          this.longitud = center.lng;
          this.map.setView(center, 17);
          this.marker.setLatLng(center);
          this.changeGeolocation(this.latitud, this.longitud);
        })
        .addTo(this.map);
      }

      changeGeolocation(lat: number, lng: number): void {

        if (this.orignalLat != lat || this.orignalLng != lng) {
          this.change = false;
        }
        fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`)
          .then(res => res.json())
          .then(data => {
            this.address = data.display_name;
          })
          .catch(err => {
            console.error('Error en geolocalización inversa', err);
          });
      }

  save() {
    this.modalLoad = this._modal.open(LoadingPopupComponent);
    let body = {
      "latitude": this.latitud,
      "longitude": this.longitud
    }
    this._device.setModuleCfgRemote(this.device, body, 'geolocation').subscribe((data) => {
      setTimeout(() => {
        this.modalLoad.close();
      }, 500);
      this.successMessage = true;
      setTimeout(() => {
        this.successMessage = false;
      }, 10000);
    }, err => {
      console.error(err)
      this.error = err.error.message;
      setTimeout(() => {
        this.error = '';
      }, 10000);
      this.modalLoad.close();
    })
  }

  restoreData() {
    this.change = true;
    this.marker.remove()
    this.marker = L.marker([this.orignalLat, this.orignalLng]).addTo(this.map);
    this.changeGeolocation(this.orignalLat, this.orignalLng);
  }
}
